import { combineReducers } from 'redux';
import { APP } from "../constants";
import appReducer from './appReducer';
import homeReducer from './homeReducer';
import viewerReducer from './viewerReducer';
import imageReducer from './imageReducer';
import reportReducer from './reportReducer';
import downloadReducer from './downloadReducer';

const appReducers = combineReducers({
  app: appReducer,
  home: homeReducer,
  viewer: viewerReducer,
  image: imageReducer,
  report: reportReducer,
  download: downloadReducer,
});

const rootReducer = (state, action) => {
  if (action.type === APP.RESET_STORE) {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
